"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.23.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import '../../styled-system/css/css.mjs';
import '../../styled-system/helpers.mjs';
import { sva } from '../../styled-system/css/sva.mjs';

const dataBuilderRowRecipe = sva({
  className: "data-builder-row",
  slots: ["row"],
  base: {
    row: {
      w: "full",
      position: "relative",
      display: "flex",
      flexDir: "row",
      flexWrap: "nowrap",
      alignItems: "stretch",
      justifyContent: "start"
    }
  },
  variants: {
    span: {
      short: {
        row: {
          width: "fit-content"
        }
      },
      default: {}
    }
  }
});
function Row({ children, className, span, ...rest }) {
  const styles = dataBuilderRowRecipe({ span });
  return /* @__PURE__ */ jsx("div", { className: clsx(styles.row, className), ...rest, children });
}

export { Row, dataBuilderRowRecipe };
